import React, {useEffect, useState} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack} from "@mui/material";
import EntityList from "./EntityList";
import ButtonExit from "../../button/ButtonExit";
import ButtonAdd from "../../button/ButtonAdd";
import TextFieldValidation from "../customer-detales/TextFieldValidation";
import OrderDatePicker from "../../datepicker/OrderDatePicker";
import {Box} from "@mui/system";
import DateTimeUtil from "../../../../utils/common/DateTimeUtil";

const ModalUpdateStatus = ({
                               title,
                               data,
                               setData,
                               open,
                               handleClose,
                               values,
                               setValues,
                               currentEditRowId,
                               currentAllowedStatuses,
                               statusesList,
                               field,
                               unableStatus,
                               handleModalAlert,
                               isPlane,
                               handleSearchQuery,
                               globalFilter,
                               loading,
                               setLoading
                           }) => {
        const [date, setDate] = useState(null);

        useEffect(() => {
            isPlane && setDate(values?.planned)
        }, [open]);

        const handleSubmit = () => {
            setLoading(true)
            const newData = isPlane ? {
                "id": values.id,
                "name": values.name,
                "planState": values.planState,
                "planned": date
            } : values[field]
            unableStatus(values.id, newData,
            ).then(function (response) {
                const newData = isPlane ? data.map(el => el.id === values.id ? {...el, ...response.data} : el) : data.filter(el => el.id !== values.id || el.id === values.id && values[field] !== 'ARCHIVE').map(el => el.id === values.id ? values : el)
                setData(newData)
                handleSearchQuery(globalFilter, newData)
                handleClose();
                handleModalAlert("Данные изменены", 'success')
            })
                .catch(function (error) {
                    handleModalAlert(error);
                })
                .finally(() => setLoading(false))
        }

        return (
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle textAlign="center">{title}</DialogTitle>
                <DialogContent>
                    <form onSubmit={(e) => e.preventDefault()}>
                        <Stack
                            sx={{
                                width: '100%',
                                minWidth: {xs: '300px', sm: '360px', md: '400px'},
                                gap: '1.5rem',
                            }}
                        >
                            <EntityList
                                label="Статус"
                                values={values}
                                setValues={setValues}
                                field={field}
                                allowedStatuses={currentAllowedStatuses}
                                statusesList={statusesList}
                            />
                            {isPlane && <Box>
                                <TextFieldValidation
                                    name={"name"}
                                    value={values?.name}
                                    label="Наименование"
                                    setCurrValues={setValues}
                                    margin={"name"}/>
                                <OrderDatePicker
                                    label={'Дата планирования'}
                                    date={date}
                                    setDate={setDate}
                                    margin={"dense"}
                                />
                            </Box>}
                        </Stack>
                    </form>
                </DialogContent>
                <DialogActions sx={{p: '1.25rem'}}>
                    <ButtonExit text={"Выйти"} onClick={handleClose}/>
                    <ButtonAdd loading={loading} text={"Обновить"} onClick={handleSubmit}/>
                </DialogActions>
            </Dialog>
        );
    }
;

export default ModalUpdateStatus;